// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CategoriesUI_view__NoKdP {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.CategoriesUI_loader__YN1ds {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1;
  padding: 2.5rem;
}

.CategoriesUI_picture-icon__wWhMO {
  font-size: 1.125rem;
  color: #1890ff;
  cursor: pointer;
}

.CategoriesUI_image-container__9yeBx {
  padding: 0.375rem;
  text-align: center;
  >div.CategoriesUI_icon__rNU3P {
    background-color: #e0e0e0;
    border-radius: 0.25rem;
    padding: 0.375rem;
    >img {
      width: 2rem;
      height: 2rem;
      aspect-ratio: 1/1;
    }
  }
  img {
    max-width: 17.5rem;
    max-height: 8.75rem;
    object-fit: contain;
    border-radius: 0.25rem;
  }
  >div {
    margin-top: 0.25rem;
    font-size: 0.75rem;
    color: #888;
  }
}

.CategoriesUI_dragger__EhEsh {
  cursor: grab;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.125rem;
  color: #8c8c8c;
  transition: color 0.2s, transform 0.2s;
}

.CategoriesUI_dragger__EhEsh:hover {
  color: #1890ff;
  transform: scale(1.2);
}

.CategoriesUI_dragger__EhEsh:active {
  cursor: grabbing;
  color: #096dd9;
}

/* Row states during dragging */

.CategoriesUI_rowDragging__BwaH9 {
  opacity: 0.4;
  background-color: #fafafa !important;
}

.CategoriesUI_rowDragOver__HbI3b {
  background-color: #e6f7ff !important;
  box-shadow: inset 0 2px 0 #1890ff, inset 0 -2px 0 #1890ff;
  transition: background-color 0.15s ease, box-shadow 0.15s ease;
}

/* Redesigned Table Previews */

.CategoriesUI_tableBannerPreview__a\\+5ny {
  width: 3rem;
  height: 3rem;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #e8e8e8;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  cursor: pointer;
  transition: transform 0.15s ease;
}

.CategoriesUI_tableBannerPreview__a\\+5ny:hover {
  transform: scale(1.05);
}

.CategoriesUI_tableBannerPlaceholder__fz8F3 {
  width: 3rem;
  height: 3rem;
  background-color: #f5f5f5;
  border-radius: 4px;
  border: 1px dashed #d9d9d9;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #bfbfbf;
}

.CategoriesUI_tableIconsContainer__H1Y88 {
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
}

.CategoriesUI_tableIconBox__F1BN\\+ {
  width: 32px;
  height: 32px;
  background-color: #f0f2f5;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.15s ease;
}

.CategoriesUI_tableIconBox__F1BN\\+:hover {
  background-color: #e6f7ff;
  border-color: #1890ff;
  transform: scale(1.05);
}

.CategoriesUI_tableIconImage__zsZK5 {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.CategoriesUI_tableIconPlaceholder__Hi\\+3l {
  color: #bfbfbf;
  font-size: 14px;
}

.CategoriesUI_tableContainer__1wf3s {
  background: #fff;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.CategoriesUI_toolbar__IM36W {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;
}

.CategoriesUI_channelTitle__qbsLF {
  font-size: 16px;
}

.CategoriesUI_channelSelect__f7dUw {
  width: 220px;
}

.CategoriesUI_actionButton__Wmzu7 {
  display: inline-flex;
  align-items: center;
}

.CategoriesUI_badgeStyle__oEZZw {
  background-color: #108ee9;
}

.CategoriesUI_popoverIconsContainer__2kKyI {
  display: flex;
  gap: 16px;
  padding: 8px;
  align-items: center;
}

.CategoriesUI_popoverIconWrapper__qz-yA {
  background: #f0f0f0;
  padding: 8px;
  border-radius: 4px;
  display: inline-block;
}

.CategoriesUI_popoverIconImage__nKLZY {
  width: 48px;
  height: 48px;
  object-fit: contain;
}

.CategoriesUI_popoverIconPlaceholder__Lkfh9 {
  font-size: 24px;
  color: #ccc;
}

.CategoriesUI_popoverLabel__JVWPC {
  font-size: 11px;
  color: #666;
  margin-top: 4px;
  font-weight: bold;
}

`, "",{"version":3,"sources":["webpack://./src/pages/categories/styles/CategoriesUI.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAElB;IACE,yBAAyB;IACzB,sBAAsB;IACtB,iBAAiB;IAEjB;MACE,WAAW;MACX,YAAY;MACZ,iBAAiB;IACnB;EACF;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;EACxB;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;EACb;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,+BAA+B;;AAC/B;EACE,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,yDAAyD;EACzD,8DAA8D;AAChE;;AAEA,8BAA8B;;AAC9B;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,sCAAsC;EACtC,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB","sourcesContent":[".view {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  padding: 2.5rem;\n}\n\n.picture-icon {\n  font-size: 1.125rem;\n  color: #1890ff;\n  cursor: pointer;\n}\n\n.image-container {\n  padding: 0.375rem;\n  text-align: center;\n\n  >div.icon {\n    background-color: #e0e0e0;\n    border-radius: 0.25rem;\n    padding: 0.375rem;\n\n    >img {\n      width: 2rem;\n      height: 2rem;\n      aspect-ratio: 1/1;\n    }\n  }\n\n  img {\n    max-width: 17.5rem;\n    max-height: 8.75rem;\n    object-fit: contain;\n    border-radius: 0.25rem;\n  }\n\n  >div {\n    margin-top: 0.25rem;\n    font-size: 0.75rem;\n    color: #888;\n  }\n}\n\n.dragger {\n  cursor: grab;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 1.125rem;\n  color: #8c8c8c;\n  transition: color 0.2s, transform 0.2s;\n}\n\n.dragger:hover {\n  color: #1890ff;\n  transform: scale(1.2);\n}\n\n.dragger:active {\n  cursor: grabbing;\n  color: #096dd9;\n}\n\n/* Row states during dragging */\n.rowDragging {\n  opacity: 0.4;\n  background-color: #fafafa !important;\n}\n\n.rowDragOver {\n  background-color: #e6f7ff !important;\n  box-shadow: inset 0 2px 0 #1890ff, inset 0 -2px 0 #1890ff;\n  transition: background-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n/* Redesigned Table Previews */\n.tableBannerPreview {\n  width: 3rem;\n  height: 3rem;\n  object-fit: cover;\n  border-radius: 4px;\n  border: 1px solid #e8e8e8;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.05);\n  cursor: pointer;\n  transition: transform 0.15s ease;\n}\n\n.tableBannerPreview:hover {\n  transform: scale(1.05);\n}\n\n.tableBannerPlaceholder {\n  width: 3rem;\n  height: 3rem;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n  border: 1px dashed #d9d9d9;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #bfbfbf;\n}\n\n.tableIconsContainer {\n  display: flex;\n  gap: 8px;\n  justify-content: center;\n  align-items: center;\n}\n\n.tableIconBox {\n  width: 32px;\n  height: 32px;\n  background-color: #f0f2f5;\n  border: 1px solid #e8e8e8;\n  border-radius: 4px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.tableIconBox:hover {\n  background-color: #e6f7ff;\n  border-color: #1890ff;\n  transform: scale(1.05);\n}\n\n.tableIconImage {\n  width: 20px;\n  height: 20px;\n  object-fit: contain;\n}\n\n.tableIconPlaceholder {\n  color: #bfbfbf;\n  font-size: 14px;\n}\n\n.tableContainer {\n  background: #fff;\n  padding: 24px;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.channelTitle {\n  font-size: 16px;\n}\n\n.channelSelect {\n  width: 220px;\n}\n\n.actionButton {\n  display: inline-flex;\n  align-items: center;\n}\n\n.badgeStyle {\n  background-color: #108ee9;\n}\n\n.popoverIconsContainer {\n  display: flex;\n  gap: 16px;\n  padding: 8px;\n  align-items: center;\n}\n\n.popoverIconWrapper {\n  background: #f0f0f0;\n  padding: 8px;\n  border-radius: 4px;\n  display: inline-block;\n}\n\n.popoverIconImage {\n  width: 48px;\n  height: 48px;\n  object-fit: contain;\n}\n\n.popoverIconPlaceholder {\n  font-size: 24px;\n  color: #ccc;\n}\n\n.popoverLabel {\n  font-size: 11px;\n  color: #666;\n  margin-top: 4px;\n  font-weight: bold;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"view": `CategoriesUI_view__NoKdP`,
	"loader": `CategoriesUI_loader__YN1ds`,
	"picture-icon": `CategoriesUI_picture-icon__wWhMO`,
	"image-container": `CategoriesUI_image-container__9yeBx`,
	"icon": `CategoriesUI_icon__rNU3P`,
	"dragger": `CategoriesUI_dragger__EhEsh`,
	"rowDragging": `CategoriesUI_rowDragging__BwaH9`,
	"rowDragOver": `CategoriesUI_rowDragOver__HbI3b`,
	"tableBannerPreview": `CategoriesUI_tableBannerPreview__a+5ny`,
	"tableBannerPlaceholder": `CategoriesUI_tableBannerPlaceholder__fz8F3`,
	"tableIconsContainer": `CategoriesUI_tableIconsContainer__H1Y88`,
	"tableIconBox": `CategoriesUI_tableIconBox__F1BN+`,
	"tableIconImage": `CategoriesUI_tableIconImage__zsZK5`,
	"tableIconPlaceholder": `CategoriesUI_tableIconPlaceholder__Hi+3l`,
	"tableContainer": `CategoriesUI_tableContainer__1wf3s`,
	"toolbar": `CategoriesUI_toolbar__IM36W`,
	"channelTitle": `CategoriesUI_channelTitle__qbsLF`,
	"channelSelect": `CategoriesUI_channelSelect__f7dUw`,
	"actionButton": `CategoriesUI_actionButton__Wmzu7`,
	"badgeStyle": `CategoriesUI_badgeStyle__oEZZw`,
	"popoverIconsContainer": `CategoriesUI_popoverIconsContainer__2kKyI`,
	"popoverIconWrapper": `CategoriesUI_popoverIconWrapper__qz-yA`,
	"popoverIconImage": `CategoriesUI_popoverIconImage__nKLZY`,
	"popoverIconPlaceholder": `CategoriesUI_popoverIconPlaceholder__Lkfh9`,
	"popoverLabel": `CategoriesUI_popoverLabel__JVWPC`
};
export default ___CSS_LOADER_EXPORT___;
